import $ from 'jquery';
import Swiper from '../../node_modules/swiper/js/swiper.min.js';

$.addInit(function(context) {
	var base = '.b-stockListSlider';

	$(base, context).each(function(i, el){
		var $el = $(el);
		var controls = $el.closest('.l-section').find('.b-sliderArrows');

		var catalogSlider = new Swiper (el.querySelector('.b-stockListSlider-container'), {
			spaceBetween : 16,
			slidesPerView : "auto",
			navigation : {
				nextEl : controls.find('.b-sliderArrows-btn_next'),
				prevEl : controls.find('.b-sliderArrows-btn_prev')
			},
			breakpoints: {
				768: {
					slidesPerView: 3,
					spaceBetween: 16,
				},
				1380: {
					slidesPerView: 3,
				},
			}
		});
	});
});


//////////////////
// WEBPACK FOOTER
// ./src/components/b-stockListSlider.js
// module id = 50
// module chunks = 0